import { render } from "./tegsoftSidebarMenu.vue?vue&type=template&id=46f7e3a8"
import script from "./tegsoftSidebarMenu.vue?vue&type=script&lang=js"
export * from "./tegsoftSidebarMenu.vue?vue&type=script&lang=js"

import "./tegsoftSidebarMenu.vue?vue&type=style&index=0&id=46f7e3a8&lang=scss"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__